export var AlertStates;
(function (AlertStates) {
    AlertStates["Success"] = "success";
    AlertStates["Warning"] = "warning";
    AlertStates["Error"] = "error";
    AlertStates["Neutral"] = "neutral";
})(AlertStates || (AlertStates = {}));
// export type UnitType = 'temperature' | 'humidity'
export const UnitType = {
    Temperature: 'temperature',
    Humidity: 'humidity'
};
export const TemperatureUnit = {
    Celsius: 'celsius',
    Fahrenheit: 'fahrenheit'
};
